import { render, staticRenderFns } from "./EditorNavMenuAddItemDivider.vue?vue&type=template&id=25426d1f&"
import script from "./EditorNavMenuAddItemDivider.vue?vue&type=script&lang=js&"
export * from "./EditorNavMenuAddItemDivider.vue?vue&type=script&lang=js&"
import style0 from "./EditorNavMenuAddItemDivider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports